export default __webpack_public_path__ + "static/media/No1.d68fd271.png";